module.exports = __webpack_public_path__ + "static/assets/efc0f24a3d0ebe9ccdfd7392058f8274.gif";